import * as React from "react";
import Loading from "../../../../common/loading/loading";

interface NavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  isSubmitting?: boolean;
}

const Navigation: React.FC<NavigationProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onPrevious,
  isSubmitting = false,
}) => {
  const stepPercentage = ((currentStep + 1) / totalSteps) * 100;
  const sectionPercentage = 100 / 4;

  const getSectionFill = (section: number) => {
    if (stepPercentage >= sectionPercentage * section) {
      return 100;
    } else if (stepPercentage > sectionPercentage * (section - 1)) {
      return (
        ((stepPercentage - sectionPercentage * (section - 1)) /
          sectionPercentage) *
        100
      );
    }
    return 0;
  };

  const isLastStep = currentStep === totalSteps - 1;



  return (
    <div className="w-full mt-8 bg-primary p-10 rounded-t-3xl">
      <div className="flex space-x-4 mb-8">
        {[1, 2, 3, 4].map((section) => (
          <div
            key={section}
            className="relative w-full h-4 bg-gray-500 rounded-full"
          >
            <div
              className="absolute top-0 left-0 h-full bg-white rounded-full transition-width duration-300"
              style={{ width: `${getSectionFill(section)}%` }}
            ></div>
          </div>
        ))}
      </div>

      <div className="flex justify-between">
        <button
          onClick={onPrevious}
          className={`px-4 py-2 rounded-md bg-gray-300 ${
            currentStep === 0 || isSubmitting ? "cursor-not-allowed opacity-50" : ""
          }`}
          disabled={currentStep === 0 || isSubmitting}
        >
          Previous
        </button>
        <button
          onClick={onNext}
          className={`px-4 py-2 rounded-md bg-blue-500 text-white flex items-center justify-center min-w-[100px] ${
            isSubmitting ? "cursor-not-allowed opacity-75" : ""
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            isLastStep ? (
              <div className="flex items-center">
                <Loading size="small" text="" className="mr-2" />
                <span>Creating...</span>
              </div>
            ) : (
              <Loading size="small" text="" className="mx-2" />
            )
          ) : (
            isLastStep ? "Finish" : "Next"
          )}
        </button>
      </div>
    </div>
  );
};

export default Navigation;
